import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IColumn, IRowAction } from './ti-grid.interfaces';
import { isNullOrUndefined } from 'util';
import { consumeBinding } from '@angular/core/src/render3/instructions';

@Component({
    selector: 'ti-grid',
    template: `<table class="table table-striped table-bordered">
  <thead *ngIf="columns">
  <tr>
    <th style="width: 50px" *ngIf="checkbox"></th>
    <th *ngFor="let column of columns">
      <div class="column-options-toggle" *ngIf="column.showColumnFilter">
        <i class="fal fa-align-right column-options-toggle-btn" (click)="toggleColumnOptions(columnActions)"></i>
        <div class="column-options" #columnActions>
          <ul>
            <li>
              <div class="filter">
                <select [(ngModel)]="column.filterOperator">
                  <option value="has">Contains</option>
                  <option value="=">Equal to</option>
                  <option value="!=">Not Equal to</option>
                  <option value=">">Greater than</option>
                  <option value=">=">GT or Equal</option>
                  <option value="<">Less than</option>
                  <option value="<=">LT or Equal</option>
                </select>
                <input [(ngModel)]="column.showColumnFilter" placeholder="Filter by"/>
              </div>
            </li>
            <li>
              <div class="items-check" *ngFor="let item of columnValues(column)">
                <div *ngIf="column.excludes.indexOf(item) === -1; else emptyCheckbox">
                  <div (click)="include(column, item)">
                    <i class="fal fa-check-square"></i>
                    <span>{{ item }}</span>
                  </div>
                </div>
                <ng-template  #emptyCheckbox>
                  <div (click)="exclude(column, item)">
                    <i  class="fal fa-square"></i>
                    <span>{{ item }}</span>
                  </div>
                </ng-template>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div (click)="toggleColumnSort(column)">
        <i class="fal fa-sort-amount-down m-r-5" *ngIf="column.sort == 'desc'"></i>
        <i class="fal fa-sort-amount-up m-r-5" *ngIf="column.sort == 'asc'"></i>
        <span class="column-title">{{ column.title }}</span>
        <span class="filter-badge" (click)="column.filterText = ''" *ngIf="column.filterText">
                    <span *ngIf="['=','has'].indexOf(column.filterOperator) < 0">
                    {{column.filterOperator}}
                    </span>
                    {{ column.filterText }} &nbsp; <i class="fal fa-times"></i>
                    </span>
        <span class="filter-badge" (click)="column.excludes = []" *ngIf="column.excludes.length > 0">
                    excludes {{ column.excludes.join(', ') }} &nbsp; <i class="fal fa-times"></i>
                    </span>
      </div>
    </th>
  </tr>
  </thead>
  <tbody (click)="hideColumnOptions()">
  <tr>
    <th *ngIf="checkbox" class="text-center p-0 va-middle">
      <i class="fal fa-search"></i>
    </th>
    <th *ngFor="let column of columns" class="p-0">
      <input class="form-control clean-input"
             [ngModel]="column?.filterText"
             (ngModelChange)="searchColumn($event, column)"  >
    </th>
  </tr>
  <tr *ngIf="selectedRow">
    <td colspan="100%">
                <span *ngFor="let action of rowActions"
                      (click)="action.onClick(selectedRow); selectedRow = null"
                      class="m-r-20 pointer {{action.classes}}">
                <i [class]="action.icon"></i> &nbsp; {{ action.title }}
                </span>
    </td>
  </tr>
  <ng-container *ngFor="let row of filteredRows">
    <tr>
      <td class="text-center" *ngIf="checkbox">
        <i class="fal fa-check-square pointer" (click)="selectedRow = null" *ngIf="selectedRow === row"></i>
        <i class="fal fa-square pointer"  (click)="selectedRow = row" *ngIf="selectedRow !== row"></i>
      </td>
      <td
              *ngFor="let column of columns"
              (click)="onCellClicked(row, column)"
              class="{{ column.classes }} {{ column.onClick ? 'pointer' : '' }} text-{{column.align}}">
        <div [innerHTML]="column.template(row[column.field], column, row)">
        </div>
      </td>
    </tr>
  </ng-container>
  <tr *ngIf="filteredRows.length === 0">
    <td class="no-records" colspan="100%">
      <div *ngIf="!this.rows">
        <i class="fal fa-2x fa-spin fa-spinner-third"></i>
      </div>
      <div *ngIf="this.rows">
        <div class="fal fa-5x fa-compress-alt"></div>
        <div>
          No records
        </div>
      </div>
    </td>
  </tr>
  </tbody>
  <tfoot>
  <tr>
    <td colspan="100%">
      <div class="page-index">
                    <span *ngFor="let pg of pages; let i = index">
                        <ng-container *ngIf="i > 0 && pages[i] - pages[i-1] > 1">
                            ...
                        </ng-container>
                        <span (click)="refreshGrid(pg)" class="page-index-selector {{ currentPage == pg ? 'active' : ''}}">{{ pg }}</span>
                    </span>
      </div>
      <div>Showing {{ (totalCount == 0 && currentPage == 1) ? 0 : (currentPage - 1) * pageSize + 1}}-{{ currentPage * pageSize > totalCount ? totalCount : currentPage * pageSize}} of {{totalCount}}</div>
    </td>
  </tr>
  </tfoot>
</table>
`,
    styles: [`thead th{cursor:pointer;vertical-align:top;background:#17aaba;color:#f1f1f1;position:relative}th .column-title{padding-right:30px}.column-options-toggle{opacity:.3;position:absolute;right:1em;top:.75em}th:hover .column-options-toggle{opacity:1}.column-options{position:absolute;right:0;top:100%;width:300px;opacity:1;color:#000000FF;border:1px solid #ddd;background:#fff;display:none;transition:all .4s ease-out;box-shadow:10px 17.321px 57px 0 rgba(0,0,0,.08)}li,ul{list-style:none;margin:0;padding:0}ul li{padding:.5em 1em;display:block;border-bottom:1px solid #ddd}ul li ul li:last-child{border-bottom:none}ul li:hover{background:#f4f4f4}ul li div.filter{display:flex;flex-wrap:nowrap;align-items:flex-start}ul li div.filter input,ul li div.filter select,ul li div.filter span{padding:.25rem .75rem;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;width:50%;display:inline-block}ul li div.filter span{width:auto}.items-check>div{padding:.25em;border-bottom:1px solid #e5e5e5}.items-check>div i{margin-right:.5em;font-size:1.2em}.items-check:last-child div{border-bottom:none}.m-r-20{margin-right:20px}.m-r-5{margin-right:5px}.m-r-10{margin-right:10px}.pointer{cursor:pointer}.no-records{text-align:center;color:#495057;padding:20px}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.text-justify{text-align:justify}.va-middle{vertical-align:middle}.p-0{padding:0}input.form-control.clean-input{border-radius:0;margin:0;width:100%;border:0;background:0 0}input.form-control.clean-input:active,input.form-control.clean-input:focus{box-shadow:none}.filter-badge{font-size:.7em;border-radius:2px;width:auto;display:inline-block;background:#333;color:#e4e4e4;padding:.25em .5em;margin-left:1em;max-width:150px}.page-index{float:right}.page-index .page-index-selector{cursor:pointer;padding:0 .5em;display:inline-block;text-align:center;border:1px solid transparent}.page-index .page-index-selector.active{border:1px solid #495057}.page-index .page-index-selector:hover{background:#e4e4e4}`]
})
export class TiGridComponent implements OnInit {

    @Input() columns: IColumn[];
    @Input() url: string;
    @Input() rows: any[];
    @Input() rowActions: IRowAction[];
    @Input() pageSize = 10;
    @Input() currentPage = 1;
    @Input() checkbox = true;
    @Input() customPaging = false;

    @Output()
    gridStateChanged: EventEmitter<number> = new EventEmitter<number>();

    selectedRow: any;

    @Input() headers: HttpHeaders | { [header: string]: string | string[] };

    @Input() totalCount = 0;
    filteredCount = 0;

    constructor(private http: HttpClient) {
    }

    ngOnInit() {
        this.columns.forEach(c => {
            c.filterOperator = c.filterOperator || 'has';
            c.showColumnFilter = c.showColumnFilter || false;
            c.excludes = c.excludes || [];
            c.template = c.template || ((v) => v);
            c.onFilter = c.onFilter || ((v) => v);
            c.filterOperator = 'has';
        });

        if (this.url) {
            this.fetchCurrentPage();
        } else {
            if (!this.customPaging){
                this.totalCount = this.rows ? this.rows.length : 0;
            }
        }
    }

    fetchCurrentPage() {
        const url = `${this.url}?page=${this.currentPage}&pageSize=${this.pageSize}`;
        this.http.get<any>(url, {headers: this.headers}).subscribe(response => {
            console.log(response instanceof Array);
            if (response instanceof Array) {
                this.rows = response;
                this.totalCount = this.rows.length;
            } else {
                if (response.total) {
                    this.totalCount = response.total;
                }
                if (response.data && response.data instanceof Array) {
                    this.rows = response.data;
                }
            }
            console.log("TotalCount", this.totalCount);
        });
    }

    columnValues(column: IColumn): any[] {
        if (!this.rows) {
            return [];
        }
        return this.rows.map(r => column.template(r[column.field], column, r)).filter((v, i, a) => a.indexOf(v) === i);
    }

    get filteredRows(): number[] {


        if (!this.rows || !(this.rows instanceof Array)) {
            return [];
        }

        let rows: any[] = this.rows.concat().filter(row => !row.isDeleted);

        if (this.customPaging) {
            return this.rows;
        }

        const filterColumns = this.columns.filter(c => c.excludes.length > 0 || (c.filterText && c.filterOperator));
        const sortColumn = this.columns.find(c => c && c.sort === 'asc' || c.sort === 'desc' );

        if (sortColumn) {
            rows = this.applyColumnSort(rows, sortColumn);
        }

        // Apply filters
        filterColumns.forEach(column => {
            rows = this.applyColumnFilter(rows, column);
        });

        this.filteredCount = rows.length;


        rows = rows.splice((this.currentPage - 1) * this.pageSize, this.pageSize);

        return rows;
    }

    applyColumnFilter(rows: any[], column: IColumn): any[] {
        return rows.filter(row => {

            let accept = true;
            const actualValue = column.template(row[column.field], column, row);

            if (column.excludes.indexOf(actualValue) >= 0) {
                return false;
            }

            switch (column.filterOperator) {

                case 'has':
                    accept = actualValue.toString().toLowerCase().indexOf(column.filterText.toString().toLowerCase()) >= 0;
                    break;

                case '=':
                    accept = actualValue == column.filterText;
                    break;

                case '!=':
                    accept = actualValue != column.filterText;
                    break;

                case '>':
                    accept = actualValue > column.filterText;
                    break;

                case '>=':
                    accept = actualValue >= column.filterText;
                    break;

                case '<':
                    accept = actualValue < column.filterText;
                    break;

                case '<=':
                    accept = actualValue <= column.filterText;
                    break;

                default:
                    break;
            }

            return accept;
        });
    }

    applyColumnSort(rows: any[], column: IColumn): any[] {

        // Gives the integer array of the passed 1-dimensional array
        const indices = this.getSortedIndices(rows.map(r => column.template(r[column.field], column, r)), column.sort);

        return indices.map(v => rows[v]);
    }

    // Gives the integer array of the passed 1-dimensional array
    getSortedIndices(arr: any[], sortBy: 'asc' | 'desc' | null): number[] {

        // Clone rows
        // Replace undefined with null
        // Because later we use undefined as index
        arr = arr.map(v => v === undefined ?  null : v);

        let sorted: any[];

        if (sortBy === 'desc') {
            sorted = arr.slice().sort().reverse();
        } else {
            sorted = arr.slice().sort();
        }

        return sorted.map(v => {
            const index = arr.indexOf(v);
            arr[index] = undefined;
            return index;
        });

    }

    hideColumnOptions() {
        // Hide all other context menus
        const toHide: any[] = Array.from(document.querySelectorAll('.column-options'));
        toHide.forEach(e => e.style.display = 'none');
    }

    onCellClicked(row: any, column: IColumn) {
        if (column.onClick) {
            column.onClick(row[column.field], row, column);
        }
    }

    include(column: IColumn, value: any) {
        column.excludes.push(value);
    }

    exclude(column: IColumn, value: any) {
        const index = column.excludes.indexOf(value);
        if (index >= 0) {
            column.excludes.splice(index, 1);
        }
    }

    searchColumn(searchText: string, column: IColumn) {
        column.filterOperator = 'has';
        column.filterText = searchText;
        this.refreshGrid();
    }

    get pages(): number[] {
        let _pages =  Array.from(Array(Math.ceil(this.totalCount / this.pageSize)))
            .map((v, i) => i + 1);
        if (_pages.length > 5) {
            _pages = _pages.filter((v, i) => [1, this.currentPage - 1, this.currentPage, this.currentPage + 1, _pages.length].indexOf(v) >= 0);
        }
        return _pages;
    }

    toggleColumnOptions(element) {

        // Hide all other context menus
        const toHide: any[] = Array.from(document.querySelectorAll('.column-options'))
            .filter(e => e !== element);

        toHide.forEach(e => e.style.display = 'none');

        if (element.style.display === 'block') {
            element.style.display = 'none';
        } else {
            element.style.display = 'block';
        }
    }

    toggleColumnSort(column: IColumn) {
        this.columns.filter(c => c !== column).forEach(c => c.sort = null);
        column.sort = (column.sort === 'asc') ? 'desc' : 'asc';
        this.refreshGrid();
    }

    refreshGrid(page?: number) {
        this.currentPage = page || this.currentPage;
        this.gridStateChanged.emit(this.currentPage);
    }

}
